// extracted by mini-css-extract-plugin
module.exports = {"stubContainer":"styles_stubContainer__27wte","leftColumn":"styles_leftColumn__1SzIK","button":"styles_button__clnFk","searchAccess":"styles_searchAccess__jhvuf"};